var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('transition', {
    staticClass: "GlobalLoader",
    attrs: {
      "name": "page",
      "mode": "out-in"
    },
    on: {
      ":after-leave": _vm.animationFinished
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showGlobalLoader,
      expression: "showGlobalLoader"
    }],
    staticClass: "GlobalLoader-mask"
  }, [_c('div', {
    staticClass: "GlobalLoader-loaderContainer"
  }, [_c('div', {
    staticClass: "GlobalLoader-image"
  }, [_c('div', {
    ref: "loaderElement"
  })])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }